export default __webpack_public_path__ + "static/media/PropostasExpiradas.8d246aee.svg";